import {createContext} from 'react';


// @ts-ignore
export const Context = createContext();
export enum TYPE_MODAL_ORDER {
    DEFAULT,
    PAY_ORDER,
    MULTI_PAY_ORDER,
    RETURN_PAY
}

export enum TYPE_STOCK {
    MANUAL,
    AUTOMATIC,
    PROMO_CODE
}
export enum RETURN_PAY_TYPES  {
    IN_CASH,
    CARD,
    FROM_DEPOSIT_MINUTES=3,
    CERTIFICATE=6,
    TRANSFER=10,
    MONEY_DEPOSITS=2,
    ONLINE=4
}
export const PAYMENT_RETURN_PAY_ITEMS = [
    {
        id: RETURN_PAY_TYPES.IN_CASH,
        title: 'Наличными'
    },
    {
        id: RETURN_PAY_TYPES.CARD,
        title: 'На карту'
    },
    {
        id: RETURN_PAY_TYPES.TRANSFER,
        title: 'Банковский перевод'
    },
    {
        id: RETURN_PAY_TYPES.MONEY_DEPOSITS,
        title: 'На денежный депозит'
    },
    {
        id: RETURN_PAY_TYPES.ONLINE,
        title: 'Онлайн'
    }
]